import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const INFORMATIONSROWBLOCK_LEGACY_FIELD_ORDER = [
  "content"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  informationsRowBlockDescriptor: _generatedInformationsRowBlockDescriptor,
  informationsRowBlockBlocDefinition,
  informationsRowBlockDashboardLayout,
  informationsRowBlockConfig,
  informationsRowBlockResolveConfig,
  informationsRowBlockProperties,
} = doodBlockConfig(
  {
    name: "Information row",
    componentType: 'InformationsRowBlockComponent',
    category: 'content',
    hideFromPicker: true,
    description: "Information row.",
    keywords: [],
    allowedIn: [
      { bloc: "InformationsColumnBlockComponent", slot: "columns" },
    ],
    sharedFields: {}
  },

  () => ({
    content: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.informations-row.content.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.informations-row.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.informations-row.fieldset.text.label",
            fields: ["content"],
          },
        ],
      },
    ],
  })
);

export function informationsRowBlockDescriptor(): IBlockDescriptor;
export function informationsRowBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function informationsRowBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedInformationsRowBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedInformationsRowBlockDescriptor, informationsRowBlockProperties, fieldOrder);
}

export {
  informationsRowBlockBlocDefinition,
  informationsRowBlockDashboardLayout,
  informationsRowBlockProperties,
  informationsRowBlockConfig,
  informationsRowBlockResolveConfig,
};

export type InformationsRowBlockConfig = typeof informationsRowBlockConfig;
